import { Appointment } from "@elixir/types";
import { ReactComponent as IndianRupeeSignRegularIcon } from "../../../../assets/icons/font-awesome/indian-rupee-sign-regular.svg";
import { sendPaymentLink } from "../../../../utils/receipt";
import { ChipWithTooltip } from "ui";

const RequestPayment = ({
  apt,
  className = "",
  type,
}: {
  apt: Appointment;
  className?: string;
  type?: "primary" | "secondary";
}) => {
  return (
    <ChipWithTooltip
      onClick={() => {
        sendPaymentLink({ appointment: apt });
      }}
      className={`h-32 flex-1 ${className}`}
      icon={<IndianRupeeSignRegularIcon className="dr-min-w-14 dr-h-14" />}
      title="Request Payment"
      tooltipText="Send Request Payment Link"
      type={type}
    />
  );
};

export default RequestPayment;
